import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';

import { ReduxState, ThunkDispatchType } from 'app/redux/types';

import { ToggleSize } from 'app/design-system/components/Toggle';
import { useTranslation } from 'app/lang';

import { SwitchToTotalAmount, switchToTotalAmount } from '../../actions/entries';
import { SubmissionState } from '../../constants';
import {
  selectAnyHasLockedState,
  selectBets,
  selectSomeHasError,
  selectTotalAmountActive,
} from '../../selectors/entries';
import { selectSubmission } from '../../selectors/submission';
import InitialToggle from './Initial';

import dictionary from './Toggle.dictionary.json';

// ---

type StoreProps = {
  active: boolean;
  disabled: boolean;
};

type DispatchProp = {
  dispatch: ThunkDispatchType<SwitchToTotalAmount>;
};

type TotalAmountInputToggleProps = {
  size?: ToggleSize;
  className?: string;
};

const TotalAmountInputToggle: FC<TotalAmountInputToggleProps & StoreProps & DispatchProp> = ({
  active,
  disabled,
  dispatch,
  size,
  className,
}) => {
  const { t } = useTranslation();
  const switchToggleHandler = useCallback(() => {
    dispatch(switchToTotalAmount(!active));
  }, [active]);

  return (
    <InitialToggle active={active}
                   disabled={disabled}
                   data-test="totalAmount-toggle"
                   dataGaEvent="cart-bidUnitedToggle"
                   title={t(dictionary.totalAmountInputTitle)}
                   size={size}
                   className={className}
                   onChange={switchToggleHandler} />
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => {
  const submission = selectSubmission(state);

  const hasEntriesErrors = selectSomeHasError(state) || selectAnyHasLockedState(state);

  return {
    active: selectTotalAmountActive(state),
    disabled: (
      selectBets(state).size < 2
      || submission !== SubmissionState.AWAITING
      || hasEntriesErrors
    ),
  };
};

export default connect(mapStateToProps)(TotalAmountInputToggle);
